export function performPresenceUnsubscribe(channels, channelId, handler) {
  const channel = channels.get(channelId);
  channel.presence.leave();
  channel.presence.unsubscribe(handler);
}